export const BackOfficeUsersMiddleware = ({ dispatch }: any) => (next: any) => (action: any) => {
    if (action) {
        switch (action.type) {
            default:
                break;
        }
    }
    return next(action);
};
